import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import CandidateSelectionListTable from './components/CandidateSelectionListTable'

const CandidateSelectionList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Candidate Selection List</HeadingOne>
                    <AddItemBtn url="add-candidate-selection" title="Create" />
                </>
            }>

            <div className="col-12">
                <CandidateSelectionListTable />
            </div>
        </PageBody>
    )
}

export default CandidateSelectionList
